<template>
  <section style="display: inherit">
    <a @click="fnShowModal()" v-b-tooltip.hover title="Quote status change"
      ><i class="las la-business-time text-primary fs-1100"></i
    ></a>

    <b-modal ref="modal" size="xl" hide-footer title="Quote status - update">
      <div class="d-block">
        <div class="row">
          <div class="col-12 col-lg-6 col-md-6">
            <dl class="row">
              <dt class="col-sm-5">Quote Id</dt>
              <dd class="col-sm-7">{{ id }}</dd>
              <dt class="col-sm-5">Dealer</dt>
              <dd class="col-sm-7">{{ dealer }}</dd>
              <dt class="col-sm-5">Business manager</dt>
              <dd class="col-sm-7">{{ dealer_manager }}</dd>
              <dt class="col-sm-5">Client name</dt>
              <dd class="col-sm-7">{{ client }}</dd>
              <dt class="col-sm-5">Expected Delivery Date</dt>
              <dd class="col-sm-7">
                <datePicker
                  :editable="true"
                  value-type="YYYY-MM-DD"
                  format="DD-MM-YYYY"
                  placeholder="DD-MM-YYYY"
                  v-model="edd"
                ></datePicker>
                <div class="invalid-feedback" v-if="errors.edd">
                  {{ errors.edd[0] }}
                </div>
              </dd>
            </dl>
          </div>
          <div class="col-12 col-lg-6 col-md-6">
            <dl class="row">
              <dt class="col-sm-5">Current status</dt>
              <dd class="col-sm-7">
                <WDQuoteStatusBadge :status="status"></WDQuoteStatusBadge>
              </dd>
              <dt class="col-sm-5">Change status</dt>
              <dd class="col-sm-7">
                <div class="form-group">
                  <b-form-select
                    plain
                    autocomplete="off_status"
                    placeholder=" "
                    :options="optionStatus"
                    v-model="status"
                  ></b-form-select>
                  <div class="invalid-feedback" v-if="errors.status">
                    {{ errors.status[0] }}
                  </div>
                </div>
              </dd>

              <dt class="col-sm-5">Finance Application No.</dt>
              <dd class="col-sm-7">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="faNo"
                    placeholder=" "
                    autocomplete="off_faNo"
                    v-model="faNo"
                  />
                </div>
              </dd>
            </dl>
            <dl
              class="row"
              v-if="status == 4 || status == 5 || status == 6 || status == 7"
            >
              <dt class="col-sm-5">Financier</dt>
              <dd class="col-sm-7">
                <div class="form-group">
                  <b-form-select
                    plain
                    autocomplete="off_financier"
                    placeholder=" "
                    value-field="id"
                    text-field="name"
                    :options="getFinancierAllDropdownList"
                    v-model="financierId"
                    disabled
                  ></b-form-select>
                </div>
              </dd>
            </dl>
            <dl class="row" v-if="leadsId">
              <dt class="col-sm-5">Referring Partner</dt>
              <dd class="col-sm-7">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="referringPartner"
                    disabled
                    placeholder=" "
                    autocomplete="off_referringPartner"
                    v-model="referringPartner"
                  />
                </div>
              </dd>
            </dl>
          </div>
        </div>

        <!-- After settlement (status == 6) -->
        <div class="row" v-if="status == 6">
          <div class="col-12">
            <hr />
          </div>
          <div class="col-12 col-lg-6 col-md-6">
            <dl class="row">
              <dt class="col-sm-5">Calculation mode</dt>
              <dd class="col-sm-7">
                <div class="d-flex">
                  <b-form-checkbox
                    v-model="calculationMode"
                    name="check-button"
                    switch
                  >
                    <b>{{ calculationModeText }}</b>
                  </b-form-checkbox>
                  <WDPopCommissions
                    class="ml-2"
                    :defaultBrokerage="defaultBrokerage"
                    :defaultVsaBrokerage="defaultVsaBrokerage"
                    :defaultDealerBrokerage="defaultDealerBrokerage"
                    :dealerBrokerage="dealerBrokerage"
                    :brokerageVSA="brokerageVSA"
                    :reportingBrokerage="reportingBrokerage"
                  ></WDPopCommissions>
                </div>
              </dd>

              <dt class="col-sm-5">Finance NAF ($)</dt>
              <dd class="col-sm-7">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="financeNAF"
                    placeholder=" "
                    autocomplete="off_financeNAF"
                    v-model="financeNAF"
                  />
                  <div class="invalid-feedback" v-if="errors.financeNAF">
                    {{ errors.financeNAF[0] }}
                  </div>
                </div>
              </dd>

              <dt class="col-sm-5">Dealer Commission ($)</dt>
              <dd class="col-sm-7">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="dealerCommission"
                    placeholder=" "
                    autocomplete="off_dealerCommission"
                    v-model="dealerCommission"
                  />
                  <div class="invalid-feedback" v-if="errors.dealerCommission">
                    {{ errors.dealerCommission[0] }}
                  </div>
                </div>
              </dd>

              <dt class="col-sm-5" v-if="leadsId">
                Referring Partner Commission ($)
              </dt>
              <dd class="col-sm-7" v-if="leadsId">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="reportingCommission"
                    placeholder=" "
                    autocomplete="off_reportingCommission"
                    v-model="reportingCommission"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.reportingCommission"
                  >
                    {{ errors.reportingCommission[0] }}
                  </div>
                </div>
              </dd>

              <dt class="col-sm-5">VSA Commission ($)</dt>
              <dd class="col-sm-7">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="vsaCommission"
                    placeholder=" "
                    autocomplete="off_vsaCommission"
                    v-model="vsaCommission"
                  />
                  <div class="invalid-feedback" v-if="errors.vsaCommission">
                    {{ errors.vsaCommission[0] }}
                  </div>
                </div>
              </dd>

              <dt class="col-sm-5" v-if="referredByBDM">
                BDM Commission ($) by referral
              </dt>
              <dd class="col-sm-7" v-if="referredByBDM">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder=" "
                    autocomplete="off_bdmCommission"
                    v-model="bdmCommission"
                    disabled
                  />
                </div>
              </dd>

              <dt class="col-sm-5" v-if="referredByBDM">
                BDM Bonus Bucket Commission ($) by referral
              </dt>
              <dd class="col-sm-7" v-if="referredByBDM">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder=" "
                    autocomplete="off_bonusBucketCommission"
                    v-model="bonusBucketCommission"
                    disabled
                  />
                </div>
              </dd>
            </dl>
          </div>

          <div class="col-12 col-lg-6 col-md-6">
            <dl class="row">
              <dt class="col-sm-5">VSA Fee ($)</dt>
              <dd class="col-sm-7">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="leaseAdminFeeVSA"
                    placeholder=" "
                    autocomplete="off_leaseAdminFeeVSA"
                    v-model="leaseAdminFeeVSA"
                  />
                  <div class="invalid-feedback" v-if="errors.leaseAdminFeeVSA">
                    {{ errors.leaseAdminFeeVSA[0] }}
                  </div>
                </div>
              </dd>

              <dt class="col-sm-5">VSA Volume Bonus ($)</dt>
              <dd class="col-sm-7">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="volumeBonusVSA"
                    placeholder=" "
                    autocomplete="off_volumeBonusVSA"
                    v-model="volumeBonusVSA"
                    disabled
                  />
                  <div class="invalid-feedback" v-if="errors.volumeBonusVSA">
                    {{ errors.volumeBonusVSA[0] }}
                  </div>
                </div>
              </dd>

              <dt class="col-sm-5">Settlement Date</dt>
              <dd class="col-sm-7">
                <datePicker
                  :editable="true"
                  value-type="YYYY-MM-DD"
                  format="DD-MM-YYYY"
                  placeholder="DD-MM-YYYY"
                  v-model="settlementDate"
                ></datePicker>
                <div class="invalid-feedback" v-if="errors.settlementDate">
                  {{ errors.settlementDate[0] }}
                </div>
              </dd>

              <dt class="col-sm-5">Total Drive Away Cost ($)</dt>
              <dd class="col-sm-7">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="totalDriveAwayCost"
                    placeholder=" "
                    autocomplete="off_totalDriveAwayCost"
                    v-model="totalDriveAwayCost"
                    disabled
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.totalDriveAwayCost"
                  >
                    {{ errors.totalDriveAwayCost[0] }}
                  </div>
                </div>
              </dd>
            </dl>
          </div>
        </div>

        <div class="form-group">
          <label for="" class="fw-700">Notes</label>
          <b-form-textarea
            type="text"
            rows="3"
            class="form-control"
            placeholder=" "
            autocomplete="off_notes"
            v-model="notes"
          />
        </div>
        <hr />
        <div class="text-right">
          <button
            type="button"
            class="btn btn-secondary btn-sm mr-2"
            @click="hideModal"
          >
            Cancel
          </button>
          <button
            type="button"
            @click="fnUpdate()"
            class="btn btn-success btn-sm"
          >
            Update
          </button>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as quoteService from '../../services/quote.service'
import datePicker from 'vue2-datepicker'
import WDQuoteStatusBadge from '../../components/wd/WDQuoteStatusBadge.vue'
import WDPopCommissions from '../../components/wd/WDPopCommissions.vue'
import { optionStatus } from '../../services/data.service'

export default {
  name: 'ModalQuoteStatusUpdate',
  props: ['quoteId'],
  components: {
    datePicker,
    WDQuoteStatusBadge,
    WDPopCommissions
  },
  data() {
    return {
      errors: {},
      id: '',
      leadsId: '',
      status: '',
      dealer: '',
      referringPartner: '',
      edd: '',
      dealer_manager: '',
      client: '',
      settlementDate: '',
      faNo: '',

      dealerCommission: '',
      reportingCommission: '',
      vsaCommission: '',
      leaseAdminFeeVSA: '',
      financeNAF: 0,
      financierId: '',
      optionStatus: optionStatus,
      singleQuote: {},
      calculationMode: true,
      calculationModeTemp: true, // 1 is auto calculation, 0 is manual calculation

      totalDriveAwayCost: -1,
      referredByBDM: '',
      volumeBonusVSA: 0,

      defaultBrokerage: '', //This is total brokerage dealer and vsa can take it. It is 0.1, vsa brokerage:0.05 and dealer can get max 0.05 (0.05 + 0.05 = 0.1 0.1)
      defaultVsaBrokerage: '', // which is VSA default brokerage Eg.0.5 in lookup table
      defaultDealerBrokerage: '', // which is added on Dealer table and on new Dealer create
      dealerBrokerage: '', // which is added by Dealer on Submit new quote
      brokerageVSA: '', // which VSA Brokerage after adjust dealer and vsa brokerage Eg. (0.1 - default dealer brokerage)
      reportingBrokerage: '', // which is referral partner brokerage on create new referral partner
      notes: ''
    }
  },
  computed: {
    ...mapGetters(['getAdminQuotePaginate', 'getFinancierAllDropdownList']),
    bdmCommission() {
      const { referredByBDM } = this.singleQuote?.dealer

      if (!referredByBDM) {
        return
      }
      if (this.brokerageVSA >= 0.05) {
        return (Number(this.financeNAF) * 0.005).toFixed(2)
      }
      return 0
    },
    bonusBucketCommission() {
      const { referredByBDM } = this.singleQuote?.dealer

      if (!referredByBDM) {
        return
      }

      if (this.brokerageVSA >= 0.05) {
        return (Number(this.financeNAF) * 0.005).toFixed(2)
      }
      return 0
    },
    vsaCommission1() {},
    dealerBrokerage1() {},
    calculationModeText() {
      if (this.calculationMode) {
        return 'Auto'
      }
      return 'Manual'
    },
    /**
     * To convert
     * If value true as 1
     * If value false as 0
     */
    calculationModeCovert() {
      if (this.calculationMode) {
        return 1
      }
      return 0
    }
  },
  methods: {
    ...mapActions([
      'fetchAdminQuotePaginate',
      'fetchFinancierAllDropdownList',
      'fetchLookupValuesAll'
    ]),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.id = ''
      this.status = ''
      this.dealer = ''
      this.referringPartner = ''
      this.dealer_manager = ''
      this.client = ''
      this.edd = ''
      this.defaultDealerBrokerage = ''
      this.dealerCommission = ''
      this.reportingCommission = ''
      this.vsaCommission = ''
      this.financeNAF = 0
      this.settlementDate = ''
      this.leaseAdminFeeVSA = ''
      this.faNo = ''
      this.financierId = ''
      this.$refs.modal.hide()
      this.calculationMode = true
      this.notes = ''
    },
    showModal() {
      this.fetchFinancierAllDropdownList()
      this.fetchLookupValuesAll()
      this.fnQuoteSingle(this.quoteId)
      this.$refs.modal.show()
    },

    fnUpdate: async function () {
      const obj = {
        status: this.status,
        edd: this.edd,
        dealerCommission: this.dealerCommission,
        reportingCommission: this.reportingCommission,
        vsaCommission: this.vsaCommission,
        financeNAF: this.financeNAF,
        settlementDate: this.settlementDate,
        leaseAdminFeeVSA: this.leaseAdminFeeVSA,
        fa_no: this.faNo,
        bdmCommission: this.bdmCommission,
        bonusBucketCommission: this.bonusBucketCommission,
        volumeBonusVSA: this.volumeBonusVSA,
        calculationMode: this.calculationModeCovert,
        notes: this.notes
      }

      try {
        this.errors = {}
        const response = await quoteService.updateQuoteStatus(this.id, obj)
        const { status_code } = response.data

        if (status_code == 200) {
          this.fetchAdminQuotePaginate(this.getAdminQuotePaginate)

          messageService.fnSweetAlertSuccessToast(
            'Quote status',
            'Updated successfully '
          )

          this.hideModal()
        }
      } catch (error) {
        console.log(error)
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Quote status',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Quote status - updated',
              'Something wrong'
            )
            break
        }
      }
    },
    fnQuoteSingle: async function (quoteId) {
      try {
        const response = await quoteService.single(quoteId)
        let data = response.data

        this.singleQuote = response.data
        let firstName = ''
        let middleName = ''
        let lastName = ''

        this.id = data.id
        this.leadsId = data.leadsId
        this.status = data.status
        this.dealer = data?.dealer?.name || ''
        this.dealer_manager = data?.client?.created_user?.firstName || ''
        firstName = data?.client?.firstName || ''
        middleName = data?.client?.middleName || ''
        lastName = data?.client?.lastName || ''

        this.client = firstName + ' ' + middleName + ' ' + lastName
        this.edd = data.edd
        this.dealerCommission = data.client_lookup_values.dealerCommission
        this.reportingCommission = data.client_lookup_values.reportingCommission
        this.vsaCommission = data.client_lookup_values.vsaCommission
        this.financeNAF = data.client_lookup_values.financeNAF
        this.leaseAdminFeeVSA = data.client_lookup_values.leaseAdminFeeVSA
        this.settlementDate = data.settlementDate
        this.faNo = data.fa_no
        this.financierId = data.client_lookup_values.financierId
        this.brokerageVSA = data.client_lookup_values.brokerageVSA
        this.volumeBonusVSA = data.client_lookup_values.volumeBonusVSA
        this.referringPartner =
          data?.leads_vehicle_detail?.referral_partners?.name || ''
        if (data.client_lookup_values.calculationMode == 1) {
          this.calculationMode = true
        } else {
          this.calculationMode = false
        }
        this.dealerBrokerage = data.dealerBrokerage // dealerBrokerage on quote it might consider compete
        this.totalDriveAwayCost = data.totalDriveAwayCost
        this.referredByBDM = data?.dealer?.referredByBDM || ''
        this.notes = data?.client_lookup_values?.notes || ''

        this.fnCalculate(data)
      } catch (error) {
        console.log(error)
        const obj = {
          type: 'error',
          title: error.response.data.error.name,
          text: error.response.data.error.message,
          footer: 'Error code: ' + error.response.data.error.statusCode
        }

        messageService.fnSweetAlertDisplay(obj)
      }
    },
    fnCalculate(quote) {
      // This brokerage in client_lookup_values
      // It is mean sum of dealer brokerage and vsa brokerage
      this.defaultBrokerage = quote?.client_lookup_values?.brokerage

      // This is default VSA Brokerage
      this.defaultVsaBrokerage =
        quote?.client_lookup_values?.brokerageVSADefault

      // This dealer brokerage is assign on create dealer in dealers table
      this.defaultDealerBrokerage = quote?.dealer?.dealerBrokerage

      // The dealer brokerage  which assign by the dealer on generating a Quote
      this.dealerBrokerage = quote?.dealerBrokerage

      // This VSA brokerage is assigned in client_lookup_values
      // This VSA Brokerage
      this.brokerageVSA = quote?.client_lookup_values?.brokerageVSA

      if (this.status == 6 && this.calculationMode) {
        /**
         * Automatic calculation for dealer commission
         */
        this.dealerCommission = (
          Number(this.totalDriveAwayCost) * Number(this.dealerBrokerage)
        ).toFixed(2)

        /**
         * Automatic calculation for VSA commission
         */
        this.vsaCommission = (
          Number(this.totalDriveAwayCost) * Number(this.brokerageVSA)
        ).toFixed(2)

        /**
         * Automatic calculation referral partner reporting commission
         */
        if (this.leadsId) {
          const { reporting_commission } =
            this.singleQuote?.leads_vehicle_detail?.referral_partners

          this.reportingCommission = (
            Number(this.totalDriveAwayCost) * Number(reporting_commission)
          ).toFixed(2)
        }
      }

      if (this.status == 6 && !this.calculationMode) {
        /**
         * Manual calculation for dealer commission
         */
        this.dealerCommission = quote?.client_lookup_values?.dealerCommission
        /**
         * Manual calculation for VSA commission
         */
        this.vsaCommission = quote?.client_lookup_values?.vsaCommission
        /**
         * Manual calculation for Reporting commission for referral partner
         */
        this.reportingCommission =
          quote?.client_lookup_values?.reportingCommission
      }
    },
    fnVolumeBonusVSA(financeNAF) {
      let rate = 0
      const getFinancierAllDropdownList = this.getFinancierAllDropdownList
      let getFinancier = getFinancierAllDropdownList.find(
        (item) => item.id == this.financierId
      )

      if (Object.keys(getFinancier).length > 0) {
        rate = getFinancier.rate
      }
      this.volumeBonusVSA = (rate * financeNAF).toFixed(2)
      return (rate * financeNAF).toFixed(2)
    }
  },
  watch: {
    status(val) {
      this.fnCalculate(this.singleQuote)
    },
    calculationMode(val) {
      this.fnCalculate(this.singleQuote)
    },
    financeNAF(val) {
      if (val) {
        this.fnVolumeBonusVSA(val)
      }
    }
  }
}
</script>
